import styled from 'styled-components';

export const FooterStyle = styled.footer`
margin-top: 30px;
align-items: center;
display: flex;
justify-content: center;
font-weight: 500;
`
